/* eslint-disable */
/* Code generated by ng-openapi-gen DO NOT EDIT. */

import { HttpClient, HttpContext, HttpResponse } from '@angular/common/http';
import { Observable } from 'rxjs';
import { filter, map } from 'rxjs/operators';
import { StrictHttpResponse } from '../../strict-http-response';
import { RequestBuilder } from '../../request-builder';

import { WeatherResponse } from '../../models/weather-response';

export interface GetWeather$Params {
  location_id: string;
  at?: string;
}

export function getWeather(http: HttpClient, rootUrl: string, params: GetWeather$Params, context?: HttpContext): Observable<StrictHttpResponse<WeatherResponse>> {
  const rb = new RequestBuilder(rootUrl, getWeather.PATH, 'get');
  if (params) {
    rb.path('location_id', params.location_id, {});
    rb.query('at', params.at, {});
  }

  return http.request(
    rb.build({ responseType: 'json', accept: 'application/json', context })
  ).pipe(
    filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
    map((r: HttpResponse<any>) => {
      return r as StrictHttpResponse<WeatherResponse>;
    })
  );
}

getWeather.PATH = '/locations/{location_id}/weather';
